import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/** Minimal i18next setup (Stage 6). Only the weather dashboard consumes it
 * for now; add namespaces per feature as more screens go bilingual. */

export const LANG_STORAGE_KEY = 'hpdmis.lang';

const en = {
  common: {
    refresh: 'Refresh',
    loading: 'Loading',
    noData: 'No data',
    updated: 'Updated',
  },
  weather: {
    title: 'Himachal Pradesh Weather Dashboard',
    updated: 'Last updated',
    forecast: '7-day forecast',
    alerts: 'Alerts',
    rainfall: 'Rainfall (7 days)',
    temperature: 'Temperature',
    humidity: 'Humidity',
    wind: 'Wind',
    condition: 'Condition',
    districts: 'Districts',
    districtsWithData: 'Districts with data',
    activeAlerts: 'Active alerts',
    severeAlerts: 'Severe alerts',
    stations: 'Stations',
    noCurrentData: 'No current observations',
    rainfallEvents: 'rain events',
    map: 'District map',
    severeAlertsSection: 'Severe alerts (Orange / Red)',
  },
};

// Hindi strings mirror weather/views.py HINDI_TRANSLATIONS where they exist.
const hi: typeof en = {
  common: {
    refresh: 'ताज़ा करें',
    loading: 'लोड हो रहा है',
    noData: 'कोई डेटा नहीं',
    updated: 'अपडेट किया गया',
  },
  weather: {
    title: 'हिमाचल प्रदेश मौसम डैशबोर्ड',
    updated: 'अंतिम अपडेट',
    forecast: '7-दिवसीय पूर्वानुमान',
    alerts: 'चेतावनियाँ',
    rainfall: 'वर्षा (7 दिन)',
    temperature: 'तापमान',
    humidity: 'नमी',
    wind: 'हवा',
    condition: 'मौसम स्थिति',
    districts: 'ज़िले',
    districtsWithData: 'डेटा वाले ज़िले',
    activeAlerts: 'सक्रिय चेतावनियाँ',
    severeAlerts: 'गंभीर चेतावनियाँ',
    stations: 'केंद्र',
    noCurrentData: 'कोई वर्तमान अवलोकन नहीं',
    rainfallEvents: 'वर्षा घटनाएँ',
    map: 'ज़िला मानचित्र',
    severeAlertsSection: 'गंभीर चेतावनियाँ (नारंगी / लाल)',
  },
};

function storedLanguage(): string {
  try {
    return localStorage.getItem(LANG_STORAGE_KEY) ?? 'en';
  } catch {
    return 'en';
  }
}

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, hi: { translation: hi } },
    lng: storedLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React already escapes
  });
}

/** Switch UI language and persist the choice across sessions. */
export function setLanguage(lang: 'en' | 'hi') {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // storage unavailable (private mode) - still switch for this session
  }
  void i18n.changeLanguage(lang);
}

export default i18n;
